import { render, staticRenderFns } from "./StHeadlessForm.vue?vue&type=template&id=3ca898fa"
import script from "./StHeadlessForm.vue?vue&type=script&lang=ts"
export * from "./StHeadlessForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports